import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'  // <-- agregué useNavigate
import { useLocation } from 'react-router-dom'
import { FaCar, FaTools, FaCalendarAlt, FaTachometerAlt, FaOilCan, FaCheck, FaSave, FaEdit } from 'react-icons/fa'
import { supabase } from '../../supabaseClient'
import '../../styles/toggle.css'
import '../../styles/styles.css'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

const formatDate = (dateString) => {
  if (!dateString) return ''
  const [year, month, day] = dateString.split('-')
  return `${day}-${month}-${year}`
}

const getTodayLocal = () => {
  const today = new Date()
  today.setMinutes(today.getMinutes() - today.getTimezoneOffset())
  return today.toISOString().slice(0, 10)
}

const parseLocalDate = (dateString) => {
  const [year, month, day] = dateString.split('-')
  return new Date(year, month - 1, day)
}

export default function ServiceForm({ user, serviceToEdit = null, onFinish }) {
  const { id } = useParams()
  const navigate = useNavigate()  // <-- agregado
  const [form, setForm] = useState({
    fecha_service: getTodayLocal(),
    patente: '',
    marca: '',
    modelo: '',
    km: '',
    lubricante: '',
    aceite: false,
    filtro_aceite: false,
    filtro_combustible: false,
    filtro_aire: false,
    filtro_habitaculo: false,
    observaciones: '',
    proximo_service: '',
    cliente_nombre: '',
    cliente_telefono: ''
  })

  const [mensaje, setMensaje] = useState('')
  const [loading, setLoading] = useState(false)
  const [profile, setProfile] = useState(null)
  const [loadingService, setLoadingService] = useState(false)
  const location = useLocation()

  const capitalize = (str) => {
    if (!str) return ''
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
  }

  useEffect(() => {
    const fetchProfile = async () => {
      let currentUser = user
      if (!currentUser) {
        const { data, error } = await supabase.auth.getUser()
        if (error) return
        currentUser = data?.user
      }

      if (currentUser) {
        const { data: profileData } = await supabase
          .from('profiles')
          .select('first_name, last_name, lubricentro, email')
          .eq('id', currentUser.id)
          .single()

        if (profileData) setProfile(profileData)
      }
    }

    fetchProfile()
  }, [user])

  useEffect(() => {
    if (location.state?.serviceToEdit) {
      setForm({
        fecha_service: location.state.serviceToEdit.fecha_service || '',
        patente: location.state.serviceToEdit.patente || '',
        marca: location.state.serviceToEdit.marca || '',
        modelo: location.state.serviceToEdit.modelo || '',
        km: location.state.serviceToEdit.km || '',
        lubricante: location.state.serviceToEdit.lubricante || '',
        aceite: location.state.serviceToEdit.aceite || false,
        filtro_aceite: location.state.serviceToEdit.filtro_aceite || false,
        filtro_combustible: location.state.serviceToEdit.filtro_combustible || false,
        filtro_aire: location.state.serviceToEdit.filtro_aire || false,
        filtro_habitaculo: location.state.serviceToEdit.filtro_habitaculo || false,
        observaciones: location.state.serviceToEdit.observaciones || '',
        proximo_service: location.state.serviceToEdit.proximo_service || '',
        cliente_nombre: location.state.serviceToEdit.cliente_nombre || '',
        cliente_telefono: location.state.serviceToEdit.cliente_telefono || '',
        id: location.state.serviceToEdit.id
      })
    }
  }, [location.state])

  useEffect(() => {
    const fetchServiceById = async () => {
      if (serviceToEdit) return
      if (!id) return

      setLoadingService(true)
      const { data, error } = await supabase
        .from('services')
        .select('*')
        .eq('id', id)
        .single()

      if (error) {
        setMensaje('❌ Error al cargar service: ' + error.message)
      } else {
        setForm({
          fecha_service: data.fecha_service || '',
          patente: data.patente || '',
          marca: data.marca || '',
          modelo: data.modelo || '',
          km: data.km || '',
          lubricante: data.lubricante || '',
          aceite: data.aceite || false,
          filtro_aceite: data.filtro_aceite || false,
          filtro_combustible: data.filtro_combustible || false,
          filtro_aire: data.filtro_aire || false,
          filtro_habitaculo: data.filtro_habitaculo || false,
          observaciones: data.observaciones || '',
          proximo_service: data.proximo_service || '',
          cliente_nombre: data.cliente_nombre || '',
          cliente_telefono: data.cliente_telefono || '',
          id: data.id
        })
      }

      setLoadingService(false)
    }

    fetchServiceById()
  }, [id, serviceToEdit])

  if (loadingService) return <div>Cargando service...</div>

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    let newValue = type === 'checkbox' ? checked : value

    if (name === 'patente' || name === 'lubricante') {
      newValue = value.toUpperCase()
    } else if (['marca', 'modelo', 'observaciones'].includes(name)) {
      newValue = capitalize(value)
    }

    setForm({ ...form, [name]: newValue })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMensaje('')

    try {
      const { data: { user: currentUser } } = await supabase.auth.getUser()
      if (!currentUser) throw new Error('No hay usuario autenticado.')
      if (!profile) throw new Error('No se pudo cargar el perfil.')

      const empleado_nombre = [profile.first_name, profile.last_name].filter(Boolean).join(' ').trim()
      const empleado_email = currentUser.email || profile.email || ''

      const payload = {
        ...form,
        fecha_service: form.fecha_service,
        patente: form.patente.toUpperCase(),
        marca: form.marca ? capitalize(form.marca) : '',
        modelo: form.modelo ? capitalize(form.modelo) : '',
        lubricante: form.lubricante ? form.lubricante.toUpperCase() : '',
        observaciones: form.observaciones ? capitalize(form.observaciones) : '',
        km: form.km !== '' ? parseInt(form.km, 10) : null,
        proximo_service: form.proximo_service !== '' ? parseInt(form.proximo_service, 10) : null,
        cliente_nombre: form.cliente_nombre ? capitalize(form.cliente_nombre) : '',
        cliente_telefono: form.cliente_telefono || '',
        lubricentro: profile.lubricentro,
        empleado_id: currentUser.id,
        empleado_nombre,
        empleado_email
      }

      let error
      if (form.id) {
        ;({ error } = await supabase.from('services').update(payload).eq('id', form.id))
        if (!error) {
          // resetear form y redirigir a /empleado después de editar
          setForm({
            fecha_service: getTodayLocal(),
            patente: '',
            marca: '',
            modelo: '',
            km: '',
            lubricante: '',
            aceite: false,
            filtro_aceite: false,
            filtro_combustible: false,
            filtro_aire: false,
            filtro_habitaculo: false,
            observaciones: '',
            proximo_service: '',
            cliente_nombre: '',
            cliente_telefono: ''
          })
          navigate('/empleado')
        }
      } else {
        ;({ error } = await supabase.from('services').insert([payload]))
        if (!error) {
          setForm({
            fecha_service: getTodayLocal(),
            patente: '',
            marca: '',
            modelo: '',
            km: '',
            lubricante: '',
            aceite: false,
            filtro_aceite: false,
            filtro_combustible: false,
            filtro_aire: false,
            filtro_habitaculo: false,
            observaciones: '',
            proximo_service: '',
            cliente_nombre: '',
            cliente_telefono: ''
          })
        }
      }

      if (error) throw error
      setMensaje(form.id ? '✅ Service actualizado correctamente' : '✅ Service guardado correctamente')

      if (onFinish) onFinish()
    } catch (err) {
      setMensaje('❌ Error: ' + (err?.message || String(err)))
    } finally {
      setLoading(false)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  const CustomDateInput = ({ value, onClick }) => (
    <div className="custom-date-input" onClick={onClick}>
      <FaCalendarAlt /> {value || 'Seleccionar fecha'}
    </div>
  )

  return (
    <div className="form-container">
      <div className="form-section animate-fade-in">
        <div className="form-title">
          <FaCar className="text-accent" />
          {form.id ? 'Editar Service' : 'Cargar Nuevo Service'}
        </div>

        <form onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
          {/* Información del vehículo */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
              <FaCar className="text-primary" />
              Información del Vehículo
            </h3>
            
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Fecha del Service</label>
                <DatePicker
                  selected={form.fecha_service ? parseLocalDate(form.fecha_service) : null}
                  onChange={date => {
                    const d = new Date(date)
                    d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
                    setForm({ ...form, fecha_service: d.toISOString().slice(0, 10) })
                  }}
                  dateFormat="dd-MM-yyyy"
                  customInput={<CustomDateInput />}
                />
              </div>
              <div className="form-group">
                <label className="form-label">Patente</label>
                <input type="text" name="patente" value={form.patente} onChange={handleChange} required className="form-input" maxLength={10} />
              </div>
              <div className="form-group">
                <label className="form-label">Marca</label>
                <input type="text" name="marca" value={form.marca} onChange={handleChange} className="form-input" />
              </div>
              <div className="form-group">
                <label className="form-label">Modelo</label>
                <input type="text" name="modelo" value={form.modelo} onChange={handleChange} className="form-input" />
              </div>
              <div className="form-group">
                <label className="form-label">Kilómetros</label>
                <input type="number" name="km" value={form.km} onChange={handleChange} className="form-input" onWheel={(e) => e.target.blur()} onTouchMove={(e) => e.target.blur()} />
              </div>
              <div className="form-group">
                <label className="form-label">Lubricante</label>
                <input type="text" name="lubricante" value={form.lubricante} onChange={handleChange} className="form-input" />
              </div>
            </div>
          </div>

          {/* Cambios realizados */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
              <FaTools className="text-accent" />
              Cambios Realizados
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                { label: 'Aceite', name: 'aceite', icon: FaOilCan },
                { label: 'Filtro de aceite', name: 'filtro_aceite', icon: FaTools },
                { label: 'Filtro de combustible', name: 'filtro_combustible', icon: FaTools },
                { label: 'Filtro de aire', name: 'filtro_aire', icon: FaTools },
                { label: 'Filtro de habitáculo', name: 'filtro_habitaculo', icon: FaTools }
              ].map(item => (
                <label key={item.name} className="flex items-center justify-between p-5 rounded-lg border border-border-color transition-all cursor-pointer"
                  style={{ background: 'rgba(45, 45, 45, 0.9)' }}
                  onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(55, 55, 55, 0.95)'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(45, 45, 45, 0.9)'}
                >
                  <div className="flex items-center gap-3 flex-1 min-w-0">
                    <div className="flex-shrink-0"><item.icon className="text-white text-lg" /></div>
                    <span className="text-white font-medium truncate">{item.label}</span>
                  </div>
                  <div className="flex-shrink-0 ml-4">
                    <label className="switch">
                      <input type="checkbox" name={item.name} checked={form[item.name]} onChange={handleChange} />
                      <span className="slider"></span>
                    </label>
                  </div>
                </label>
              ))}
            </div>
          </div>

          {/* Observaciones y próximo service */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
              <FaCheck className="text-accent" />
              Información Adicional
            </h3>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Observaciones</label>
                <textarea name="observaciones" value={form.observaciones} onChange={handleChange} rows="3" className="form-input resize-none" />
              </div>
              <div className="form-group">
                <label className="form-label">Próximo Service (km)</label>
                <input type="number" name="proximo_service" value={form.proximo_service} onChange={handleChange} className="form-input" onWheel={(e) => e.target.blur()} onTouchMove={(e) => e.target.blur()} />
              </div>
            </div>
          </div>

          {/* Información del Cliente */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
              <FaCheck className="text-accent" />
              Información del Cliente
            </h3>

            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Nombre del Cliente</label>
                <input
                  type="text"
                  name="cliente_nombre"
                  value={form.cliente_nombre}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Ej: Juan Pérez"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Teléfono</label>
                <input
                  type="text"
                  name="cliente_telefono"
                  value={form.cliente_telefono}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Ej: 11 2345 6789"
                />
              </div>
            </div>
          </div>


          {/* Info del empleado y lubricentro */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
              <FaCheck className="text-accent" />
              Información del Lubricentro
            </h3>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Empleado</label>
                <div className="form-input">{profile ? `${profile.first_name} ${profile.last_name}` : 'Cargando...'}</div>
              </div>
              <div className="form-group">
                <label className="form-label">Lubricentro</label>
                <div className="form-input">{profile?.lubricentro || 'Cargando...'}</div>
              </div>
            </div>
          </div>

          <button type="submit" className="btn btn-primary w-full" disabled={loading}>
            {loading ? (<><div className="loading-spinner"></div>Guardando...</>) : (
              form.id ? (<><FaEdit /> Actualizar Service</>) : (<><FaSave /> Guardar Service</>)
            )}
          </button>
        </form>

        {mensaje && (
          <div className={`mt-4 ${mensaje.includes('✅') ? 'success' : 'error'}`}>
            {mensaje.includes('✅') ? <FaCheck /> : <FaTools />}
            {mensaje.replace('✅ ', '').replace('❌ ', '')}
          </div>
        )}
      </div>
    </div>
  )
}
